import axiosInstance from './axiosConfig';

/**
 * Get all blogs
 * @param {Object} params - Query parameters
 * @returns {Promise} Response with blogs data
 */
export const getBlogs = async (params = {}) => {
  const response = await axiosInstance.get('/laptops/blogs', { params });
  return response.data;
};

/**
 * Get blog by slug
 * @param {string} slug - Blog slug
 * @returns {Promise} Response with blog data
 */
export const getBlogBySlug = async (slug) => {
  const response = await axiosInstance.get(`/laptops/blogs/${slug}`);
  return response.data;
};
